import { Type, plainToClass, Exclude } from 'class-transformer'
import _ from 'lodash'
import { ValidatorsTypes, validEmail, isEmailUnique } from '@/modules/chatbot/controllers/AnswerValidators'

export class Dialog {
  pk: number;
  name: string;
  @Type(() => Question)
  questions: Array<Question>;
  active: boolean;

  constructor (pk:number, name: string, questions: Array<Question>, active: boolean) {
    this.pk = pk
    this.name = name
    this.active = active
    this.questions = questions
  }

  static fromJson (json:any):Dialog {
    return plainToClass(Dialog, json)
  }

  toJson (): JSON {
    return JSON.parse(JSON.stringify(this))
  }
}

export abstract class Answer {
  @Exclude()
  question: Question;
  // plainToClass doesn't handle circular dependencies so answer.question has to be set after the instance is created
  @Exclude()
  value: string;
}

export class TextAnswer extends Answer {
  placeholder?: string;
  value: string;
  validators: Array<ValidatorsTypes>
  // This field is needed so Django knows how to infer the proper Answer class
  public static resourcetype : string = 'TextAnswer'

  constructor (placeholder?: string, validators?: Array<number>) {
    super()
    this.placeholder = placeholder
    this.validators = validators
  }
}

export class SuggestionAnswer extends Answer {
  options: Array<any>
  value: string

  // This field is needed so Django knows how to infer the proper Answer class
  public static resourcetype : string = 'SuggestionAnswer'

  constructor (options: Array<any>) {
    super()
    this.options = options
  }
}

export class SelectableAnswer extends Answer {
  options: Array<any>
  many: boolean
  value: string

  // This field is needed so Django knows how to infer the proper Answer class
  public static resourcetype : string = 'SelectAnswer'

  constructor (options: Array<any>, many: boolean = false) {
    super()
    this.options = options
    this.many = many
  }
}

export class PhoneAnswer extends Answer {
  country?: string;
  value: string;

  // This field is needed so Django knows how to infer the proper Answer class
  public static resourcetype : string = 'PhoneAnswer'

  constructor (country?: string) {
    super()
    this.country = country
  }

}

export class Question {
  pk: number;
  question: string;

  @Type(() => Answer, {
    discriminator: {
      property: 'resourcetype',
      subTypes: [
        { value: TextAnswer, name: TextAnswer.resourcetype },
        { value: SelectableAnswer, name: SelectableAnswer.resourcetype },
        { value: SuggestionAnswer, name: SuggestionAnswer.resourcetype },
        { value: PhoneAnswer, name: PhoneAnswer.resourcetype }
      ]
    }
  })
  answer?: Answer;

  constructor (pk:number, question: string, answer?: Answer) {
    this.pk = pk
    this.question = question
    this.answer = answer
  }
}
